import { alertConstants, sessionConstants } from '../constants';

export const alertActions = {
    success,
    warning,
    error,
    clear
};

function success(message) {
    return { type: alertConstants.SUCCESS, message };
}

// For an action that did what was asked but with a caveat worth reading, so it
// neither claims plain success nor reports a failure that didn't happen.
function warning(message) {
    return { type: alertConstants.WARNING, message };
}

function error(message) {
  if (!message || message.length == 0) {
    return { type: sessionConstants.UNKNOWN_ACTION_TYPE };
  } else {
    return { type: alertConstants.ERROR, message };
  }
}

function clear() {
    return { type: alertConstants.CLEAR };
}
